// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__qV1IU","navy-modal":"style_navy-modal__Yh3o1"};